import script from "./CategoryFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./CategoryFormDialog.vue?vue&type=style&index=0&id=7a0800a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0800a2"]])

export default __exports__